import React, { FC, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Button, Header, Icon, Modal } from 'semantic-ui-react';
import { TranslationComponent } from '../TranslationComponent';
import { closureInitialValues, EhsPhaseClosure, EhsPhaseCreation } from './ehsFormComponents';
import { EUserRoles, IBuilding, IEhs } from '@relab/alstom-ptw-shared';
import { Form, Formik } from 'formik';

type Props = {
  buildings: IBuilding[];
  ehs: IEhs;
  userRoles: EUserRoles[];
};

export const EhsDetailPdfExporter: FC<Props> = ({ buildings, ehs, userRoles }) => {
  const [showModal, setShowModal] = useState(false);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => setShowModal(false),
  });

  return (
    <>
      <Button icon onClick={() => setShowModal(true)}>
        <Icon name="download" />
      </Button>

      <Modal size={'fullscreen'} onClose={() => setShowModal(false)} onOpen={() => setShowModal(true)} open={showModal}>
        <Modal.Content>
          <div style={{ paddingTop: 20 }} ref={componentRef}>
            <Formik initialValues={{ ...ehs, ...closureInitialValues }} onSubmit={undefined}>
              <Form className={'form ui'}>
                <Header textAlign={'center'}>{`EHS #${ehs.sequentialNumber} - ${ehs.name}`}</Header>
                <EhsPhaseCreation buildings={buildings} ehsType={ehs.ehsType} userRoles={userRoles} pdfExport />
                <Header>
                  <TranslationComponent stringKey={'Closure'} />
                </Header>
                <EhsPhaseClosure />
              </Form>
            </Formik>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button primary onClick={() => setShowModal(false)}>
            <TranslationComponent stringKey={'Back'} />
          </Button>
          <Button primary onClick={handlePrint}>
            <TranslationComponent stringKey={'Print'} />
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};
